export default {
  retrieveAdminList (state, payload) {
    state.adminList = payload.adminList

  },
  addAdminToList (state, payload) {
    state.adminList = [].concat(payload.admin_info)
  },
  getAdminInfo (state, payload) {
    state.adminInfo = payload.adminInfo
  },
  deleteAdmin (state, payload) {
    state.adminList.splice(payload.adminInfo.index, 1);
  }
}
